/* eslint-disable */
export default {
  noRecords: '找不到最近的記錄。',
  inBound: '撥入',
  outBound: '撥出',
  missed: '未接電話',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
// @key: @#@"inBound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outBound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"missed"@#@ @source: @#@"Missed Call"@#@
